<template lang="pug">
include ./../../vuek/mixins.pug

+b.FOOTER.the-footer
  +e.col
    +e.P.p Індекс сприйняття корупції базується на незалежних дослідженнях та опитуваннях, в яких беруть участь міжнародні фінансові та правозахисні експерти, в тому числі Світового банку, Freedom House, World Economic Forum, Азійського та Африканського банків розвитку тощо. Індекс є оцінкою від 0 (дуже високий рівень корупції) до 100 (украй низький рівень корупції).
  +e.col
    +e.P.p Transparency International Україна є представництвом глобальної антикорупційної мережі Transparency International, що працює більше як у 100 країнах світу. Місія ТІ Україна: знизити рівень корупції в Україні шляхом сприяння прозорості, підзвітності та доброчесності публічної влади і громадянського суспільства. Дізнатися більше <a href="http://www.ti-ukraine.org" target="_blank" class="the-footer__link">www.ti-ukraine.org</a>.
  +e.col
    +e.A.link(href="https://www.transparency.org" target="_blanck")
      +e.IMG.logo(src="static/img/25th_LogoClaim_Orig.svg")
</template>

<script>
export default {
  name: 'the-footer',
};
</script>

<style lang="scss">
@import '../../scss/styles';

.the-footer {
  display: flex;
  // border-top: solid 1px #3994d0;

  &__col {
    position: relative;
    width: calc((100% / 3) - 16px);
    padding: 20px 8px;
  }

  &__p {
    color: $color-white;
    font-weight: 400;
    font-size: 12px;
    text-align: left;
    margin: 0;
  }

  &__link {
    color: $color-blue;
    text-decoration: none;
  }

  &__logo {
    position: absolute;
    height: 80px;
    max-width: 100%;
    top: 25px;
    left: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TheFooter/TheFooter.vue